// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"22c584b4","524":"cfdc62ec"}[chunkId] + ".chunk.js";
};